import { useQuery } from '@tanstack/react-query';
import { legacyPermissionsControllerAtMeQueryOptions } from 'korint-sdk';
import { useMemo } from 'react';

export function useAccessibleCustomerIds(customerIds: string[]) {
  const { data: user } = useQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
  });

  return useMemo(() => {
    if (!user) return [];
    if (user.brokerRole) return customerIds;
    const accessibleIds = new Set(user.relations.map(r => r.resourceId));
    return customerIds.filter(id => accessibleIds.has(id));
  }, [user, customerIds]);
}
